<template>
    <div class="cart__table cart-table cart__table-check-stock">
        <table class="cart__table cart-table__table-check-stock">
            <thead class="cart-table__head">
                <tr class="cart-table-check-stock__row">
                    <th class="cart-table__column cart-table__column--image">Image</th>
                    <th class="cart-table__column cart-table__column--product">Product</th>
                    <th class="cart-table__column cart-table__column--price">Price</th>
                    <th class="cart-table__column cart-table__column--numeral">Shipping</th>
                    <th class="cart-table__column cart-table__column--total">Total</th>
                </tr>
            </thead>
            <product-item :product="product">
            </product-item>
            <tfoot class="cart-table__foot-check-stock">
                <tr>
                </tr>
            </tfoot>
        </table>
    </div>
</template>

<script>
import ProductItem from './ProductItem.vue';

export default {
    components: {
        ProductItem
    },
    props: {
        product: {
            type: Object,
            required: true
        },
    }
}
</script>